export const addTextToAlert = (alertDialog, headerText, bodyText) => {
    const alertDialogHeader = alertDialog.querySelector(".alert-dialog__body__header")
    if (alertDialogHeader &&
        (alertDialogHeader.innerText === "" || alertDialogHeader.innerText === null || alertDialogHeader.innerText === undefined)) {
        alertDialogHeader.innerText = headerText
    }

    const alertDialogText = alertDialog.querySelector(".alert-dialog__body__dialog-text")
    if (alertDialogText &&
        (alertDialogText.innerText === "" || alertDialogText.innerText === null || alertDialogText.innerText === undefined)) {
        alertDialogText.innerText = bodyText
    }
}

export const showAlertAndDisplayText = (alertDialog, headerText, bodyText) => {
    const HIDE_ALERT_TIMEOUT = 5000

    addTextToAlert(
        alertDialog,
        headerText,
        bodyText
    )
    alertDialog.classList.add("active")

    setTimeout(() => {
        alertDialog.classList.remove("active");
    }, HIDE_ALERT_TIMEOUT);
}


// WEBPACK FOOTER //
// ./javascript/product-search-page/utils/alertUtils.js